import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ynab = defineConnector({
  identifier: "ynab",
  name: "YNAB",
  tagLine: "Personal budgeting software",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.ynab\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get a personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [YNAB Developer Settings](https://app.ynab.com/settings/developer) and create a new personal access token.",
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.ynab.com/v1/budgets",
  },
});
